<template>
  <div class="relative">
    <input
      v-model.trim="query"
      type="text"
      class="input input-bordered input-sm w-full"
      :placeholder="t('search_users_placeholder')"
      @focus="isOpen = true"
    >
    <div
      v-if="isOpen && options.length"
      class="absolute z-20 mt-1 w-full bg-base-100 border border-base-300 rounded-md shadow-md max-h-56 overflow-auto"
    >
      <button
        v-for="item in options"
        :key="item.id"
        class="w-full text-left px-3 py-2 hover:bg-base-200"
        @click.prevent="select(item)"
      >
        <div class="text-sm font-medium">{{ item.name }}</div>
        <div class="text-xs opacity-70">{{ item.email }}</div>
      </button>
    </div>
  </div>
</template>

<script>
import { searchPermissionUsers } from '../lib/permissions_api'

export default {
  name: 'UserSearchInput',
  props: {
    resource: {
      type: Object,
      required: true
    },
    i18n: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['select'],
  data () {
    return {
      query: '',
      options: [],
      isOpen: false,
      debounce: null
    }
  },
  watch: {
    query () {
      window.clearTimeout(this.debounce)
      this.debounce = window.setTimeout(() => this.fetchUsers(), 220)
    }
  },
  mounted () {
    document.addEventListener('click', this.onOutsideClick)
  },
  beforeUnmount () {
    document.removeEventListener('click', this.onOutsideClick)
    window.clearTimeout(this.debounce)
  },
  methods: {
    t (key) {
      return this.i18n[key] || key
    },
    onOutsideClick (event) {
      if (!this.$el.contains(event.target)) {
        this.isOpen = false
      }
    },
    async fetchUsers () {
      if (!this.query) {
        this.options = []
        return
      }

      try {
        const json = await searchPermissionUsers(this.query, this.resource)
        this.options = json.data || []
      } catch {
        this.options = []
      }
    },
    select (item) {
      this.$emit('select', item)
      this.query = `${item.name} (${item.email})`
      this.isOpen = false
    },
    clear () {
      this.query = ''
      this.options = []
      this.isOpen = false
    }
  }
}
</script>
